import Viewport from '../stores/viewport.js'
import Emitter from './emitter.js';

let camel = (s) => s.replace(/[A-Z]/g, '-$&').toLowerCase()
export default class CustomElement extends HTMLElement {
    constructor() {
        super();

        this.events = [
            // 'eventName selector(CSS)': 'callback'
        ];

        this._props = {}
        this._events = [];

        this.matchesBreakpoint = true
        this.matchesMedia = undefined
    }

    connectedCallback() {
        this.createEvents();

        const {to, from, media} = this.dataset

        if (to || from) {
            this.hasBreakpoint = true
            this._onBreak = this.onBreak.bind(this)
            Emitter.on('break', this._onBreak)
            this.onBreak()
        }

        if (media) {
            this._onMedia = this.onMedia.bind(this)
            Emitter.on('resize', this._onMedia)
            this.onMedia()
        }
    }

    disconnectedCallback() {
        this.destroyEvents();
    }

    createEvents() {
        if (!this.events) return;

        for (let key in this.events) {
            let options= false
            let method = this.events[key];
            if (Array.isArray(method)) {
                options = method[1]
                method = method[0]
            }
            if (typeof method !== 'function') method = this[method];
            if (!method) continue;

            const match = key.match(/^(\S+)\s*(.*)$/);

            const eventName = match[1];
            const selector = match[2];
            const callback = method.bind(this);
            
            let elems = (!selector) ? [this] : Array.from(this.querySelectorAll(selector));

            if (elems.length) {
                elems.forEach((el, i) => {
                    el.addEventListener(eventName, callback, options);
                    this._events.push({eventName: eventName, selector: el, callback: callback});
                });
            }
        }
    }

    onMedia() {
        const {media} = this.dataset
        const {matches } = window.matchMedia(media)
        if (matches == this.matchesMedia) return
        this.setData({'matchesMedia': matches})
        this.onMediaquery && this.onMediaquery.call(this, {matches})
    }

    onBreak() {
        const {from, to} = this.dataset
        let matches = true
        if (from) {
            matches = Viewport.from(from)
        }
        if (matches && to) {
            matches = Viewport.to(to)
        }
        this.setData({'matchesBreakpoint': matches})
        this.onBreakpoint && this.onBreakpoint.call(this, {viewport: Viewport, matches})
    }

    setData(data) {
        Object.entries(data).forEach(([key, value]) => {
            this[key] = value
            this.setAttribute(`data-${camel(key)}`, `${value}`)
        })
    }

    destroyEvents() {
        if (this.hasBreakpoint) {
            Emitter.off('break', this._onBreak)
        }

        if(!this._events) return;
        
        this._events.forEach((event) => {
            event.selector.removeEventListener(event.eventName, event.callback);
        });


        this._events = [];
    }
}
